import React from 'react';

export default function KpiCard({ label, value, tone = 'default', emphasis = false }) {
  const toneColors = {
    default: 'var(--color-accent)',
    danger: 'var(--color-danger)',
    warning: 'var(--color-warning)',
    success: 'var(--color-success)',
  };

  return (
    <div
      className="card-interactive"
      style={{
        background: emphasis ? 'var(--color-accent-soft)' : 'var(--color-surface)',
        border: `1px solid ${emphasis ? 'var(--color-accent)' : 'var(--color-border)'}`,
        borderLeft: `3px solid ${toneColors[tone]}`,
        borderRadius: 'var(--radius-md)',
        boxShadow: emphasis ? 'var(--shadow-card-hover)' : 'var(--shadow-card)',
        padding: emphasis ? 'var(--space-5)' : 'var(--space-4)',
        flex: emphasis ? '1 1 240px' : '1 1 160px',
      }}
    >
      <div
        style={{
          fontSize: 'var(--font-size-xs)',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          color: emphasis ? 'var(--color-accent-hover)' : 'var(--color-text-muted)',
          marginBottom: 'var(--space-2)',
        }}
      >
        {label}
      </div>
      <div
        className="data-figure"
        style={{
          fontFamily: emphasis ? 'var(--font-display)' : undefined,
          fontSize: emphasis ? 'calc(var(--font-size-2xl) * 1.15)' : 'var(--font-size-2xl)',
          fontWeight: 700,
          color: 'var(--color-text-primary)',
        }}
      >
        {value}
      </div>
    </div>
  );
}
